import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ItemsModel } from '../models/ItemsModel';
import { URLsConfig } from '../URLsConfig';
import { InsuranceCompanyModel } from '../models/InsuranceCompanyModel';

@Injectable()
export class IsuranceCopmanyService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getIsuranceCopmany(insid: string ) {
      let params = new HttpParams();
        params = params.append("insid", insid);
 
        const options = {
            params: params
        };
        return this.http.get<InsuranceCompanyModel>(this.urlsconfig.WebAPIURL_Test + 'api/IsuranceCompany/GetIsuranceCompany',options);
    }

    public AddIsuranceCopmany(insurancecompanyModel: InsuranceCompanyModel) {
        return this.http.post<InsuranceCompanyModel>(this.urlsconfig.WebAPIURL_Test + 'api/IsuranceCompany/AddIsuranceCompany', insurancecompanyModel);
    }

    public DelIsuranceCopmany(insid: string ) {

      let params = new HttpParams();
        params = params.append("insid", insid);
     
        const options = {
          params: params
      };
      return this.http.get<InsuranceCompanyModel>(this.urlsconfig.WebAPIURL_Test + 'api/IsuranceCompany/DeleteIsuranceCompany',options);
    }


    public getIsuranceCopmanyLookupTop() {
      let params = new HttpParams();
 
      const options = {
          params: params
      };
      return this.http.get<InsuranceCompanyModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/IsuranceCompany/IsuranceCompanyLookupTop', options);
  }
 public getIsuranceCopmanySerial() {
      let params = new HttpParams();
        
        const options = {
            params: params
        };
        return this.http.get<InsuranceCompanyModel>(this.urlsconfig.WebAPIURL_Test + 'api/IsuranceCompany/GetIsuranceCompanySerial',options);
    }
 
}
